const HEIGHTS = [
  0.42, 0.68, 0.9, 0.55, 0.78, 0.5, 0.95, 0.62, 0.4, 0.85, 0.72, 0.48, 0.9,
  0.6, 0.36, 0.8, 0.66, 0.52, 0.92, 0.58, 0.44, 0.75, 0.88, 0.5, 0.7, 0.4,
  0.82, 0.6, 0.95, 0.46, 0.68, 0.55,
];

export default function Waveform({ bars = 32, className = "", animated = true, testid }) {
  return (
    <div
      className={`waveform ${animated ? "" : "static"} ${className}`}
      aria-hidden="true"
      data-testid={testid || "waveform"}
    >
      {Array.from({ length: bars }).map((_, i) => (
        <span
          key={i}
          className="wave-bar"
          style={{
            "--h": HEIGHTS[i % HEIGHTS.length],
            "--delay": `${(i % 9) * 0.11}s`,
            "--dur": `${0.85 + (i % 6) * 0.14}s`,
          }}
        />
      ))}
    </div>
  );
}
